import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import { createMessageGetter } from 'Components/Worksheets/Core/Helpers/messageHelpers';
import {
  IQuantity,
  isGreaterThan as isIQuantityGreaterThan,
  isLessThan as isIQuantityLessThan,
  toIQuantity,
} from 'Data/ViewModels/Core/IQuantity';
import { hasValue } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { not } from 'ramda';
import React from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, Field } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';

let AstmReportSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const disableReportInsufficientSampleMass = useSelector(
    pipe(
      createWorksheetSelector!('DryingTray.Messages'),
      createMessageGetter('WetSoilMass', 'Spectra.QESTLab.Entities.Rules.Documents.Tests.Aggsoil.MoistureContent.ASTM.Messages.ASTM_D_2216_MinimumWetSampleMassNotAchievedMessage'),
      hasValue,
      not
    )
  );
  const disableReportDryingTemperature = useSelector(
    pipe(
      createWorksheetSelector!('Equipment.DryingTemperature'),
      (t: IQuantity) =>
        isIQuantityLessThan(t, toIQuantity(105, '°C')) || isIQuantityGreaterThan(t, toIQuantity(115, '°C')),
      not
    )
  );
  const disableReportMaterialExcluded = useSelector(
    pipe(createWorksheetSelector!('Preparation.ExcludedMaterialDescription'), not)
  );
  return (
    <ListFieldSection heading="Report" single>
      <Field
        input={<Checkbox />}
        label="Insufficient Sample Mass"
        name="Results.ReportInsufficientSampleMass"
        disabled={disableReportInsufficientSampleMass}
      />
      <Field
        input={<Checkbox />}
        label="Drying Temperature"
        name="Results.ReportDryingTemperature"
        disabled={disableReportDryingTemperature}
      />
      <Field
        input={<Checkbox />}
        label="Material Excluded"
        name="Results.ReportMaterialExcluded"
        disabled={disableReportMaterialExcluded}
      />
    </ListFieldSection>
  );
};

AstmReportSection = withInjectedProps(AstmReportSection);

export { AstmReportSection };
export default AstmReportSection;
